/**
 * Paths and the destination rule shared by the finish-account page, its server
 * functions and the routes that send people to it.
 *
 * Aliases: finish account, account link
 */

import { validateRedirectPath } from "~/lib/shared/post-auth-routing";

/** The emailed link's route; it swaps the token for a cookie. */
export const ACCOUNT_LINK_PATH = "/api/account/link";

/** The page that sets an account's first password. */
export const FINISH_ACCOUNT_PATH = "/finish-account";

/** Where finishing goes when no valid destination is named. */
const DEFAULT_FINISH_DESTINATION = "/my-coaching";

/** A same-site destination for after finishing; anything else falls back. */
export function finishAccountDestination(
  next: string | null | undefined,
): string {
  return (
    (next ? validateRedirectPath(next) : null) ?? DEFAULT_FINISH_DESTINATION
  );
}

/** The finish page URL that goes on to `next` once she has a password. */
export function finishAccountHref(next: string): string {
  return `${FINISH_ACCOUNT_PATH}?next=${encodeURIComponent(finishAccountDestination(next))}`;
}

/**
 * The finish page on the direct return from Checkout: only there does its code
 * step email a code by itself.
 */
export function finishAccountAfterCheckoutHref(next: string): string {
  return `${finishAccountHref(next)}&from=checkout`;
}
